import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { collection, addDoc, getDocs, query, where, doc, updateDoc } from "firebase/firestore";
import { useNavigate, useParams } from "react-router-dom";
import "./ResumeForm.css";

export default function ResumeForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const [resume, setResume] = useState({
    name: "",
    title: "",
    email: "",
    phone: "",
    location: "",
    summary: "",
    experience: "",
    education: "",
    skills: ""
  });

  // Load resume if editing
  useEffect(() => {
    if (id) {
      loadResume(id);
    }
  }, [id]);

  const loadResume = async (resumeId) => {
    try {
      const q = query(
        collection(db, "resumes"),
        where("uid", "==", auth.currentUser.uid)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        if (doc.id === resumeId) {
          setResume(doc.data());
        }
      });
    } catch (error) {
      console.error("Error loading resume:", error);
    }
  };

  const saveResume = async () => {
    if (!resume.name.trim()) {
      alert("Please enter your name");
      return;
    }

    setLoading(true);
    try {
      const resumeData = {
        ...resume,
        uid: auth.currentUser.uid,
        createdAt: new Date(),
        updatedAt: new Date()
      };

      if (id) {
        // Update existing resume
        await updateDoc(doc(db, "resumes", id), resumeData);
        alert("Resume Updated!");
      } else {
        // Create new resume
        const docRef = await addDoc(collection(db, "resumes"), resumeData);
        alert("Resume Saved!");
        navigate(`/preview/${docRef.id}`);
      }
    } catch (error) {
      console.error("Error saving resume:", error);
      alert("Error saving resume: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setResume({ ...resume, [field]: value });
  };

  const fields = [
    { key: "name", label: "Full Name", type: "text", required: true },
    { key: "title", label: "Professional Title", type: "text" },
    { key: "email", label: "Email", type: "email" },
    { key: "phone", label: "Phone Number", type: "tel" },
    { key: "location", label: "Location", type: "text" },
    { key: "summary", label: "Professional Summary", type: "textarea", rows: 4 },
    { key: "experience", label: "Work Experience", type: "textarea", rows: 6 },
    { key: "education", label: "Education", type: "textarea", rows: 4 },
    { key: "skills", label: "Skills (comma separated)", type: "text" }
  ];

  return (
    <div className="resume-form-container">
      <h2>{id ? "Edit Resume" : "Create New Resume"}</h2>
      
      <div className="form-grid">
        {fields.map((field) => (
          <div className="form-group" key={field.key}>
            <label>
              {field.label}
              {field.required && <span className="required">*</span>}
            </label>
            {field.type === "textarea" ? (
              <textarea
                value={resume[field.key]}
                onChange={(e) => handleChange(field.key, e.target.value)}
                placeholder={`Enter ${field.label.toLowerCase()}`}
                rows={field.rows}
              />
            ) : (
              <input
                type={field.type}
                value={resume[field.key]}
                onChange={(e) => handleChange(field.key, e.target.value)}
                placeholder={`Enter ${field.label.toLowerCase()}`}
                required={field.required}
              />
            )}
          </div>
        ))}
      </div>

      <div className="form-actions">
        <button onClick={() => navigate("/dashboard")} className="btn-secondary">
          Cancel
        </button>
        <button onClick={saveResume} disabled={loading} className="btn-primary">
          {loading ? "Saving..." : (id ? "Update Resume" : "Save Resume")}
        </button>
        {resume.name && (
          <button 
            onClick={() => navigate(`/preview/${id || 'new'}`)} 
            className="btn-preview"
          >
            Preview
          </button>
        )}
      </div>
    </div>
  );
}